/**
 * FindStoreContainer
 * --
 */
import React from 'react';
import FindStorePresenter from './FindStorePresenter';
import { useGetShopInformations } from 'hooks/ShopInformationHooks';
import { STORE_URL } from 'utils';

const FindStoreContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { screenSize } = props;

  /* ===== MUTATE ===== */
  /* ===== Data ===== */
  const { data: Stores } = useGetShopInformations(
    {
      join_tables: '["shop_information_file"]',
      application_status: 'APPROVE',
      type: 'STORE',
    },
    {
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) return [];

        return data;
      },
      initialData: [],
    }
  );

  /* ===== STATE ===== */
  const [inputValue, setInputValue] = React.useState('');
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 매장 검색
   * --
   */
  const handleSearchStore = (t = 'search') => {
    setIsLoading(true);

    let arr = [];
    if (t === 'search') {
      const filterList = StoreList.filter((store) =>
        store?.shop_information_name?.includes(inputValue)
      );

      arr = filterList;
    } else {
      arr = StoreList;
    }

    setTimeout(() => {
      setData(arr);
    }, 1000);
  };

  /* ===== HOOKS ===== */
  /**
   * 매장 리스트 정제
   * --
   */
  const StoreList = React.useMemo(() => {
    const newStores = Stores.map((store) => {
      const { shop_information_file, store_information, ...rest } = store;

      const files = shop_information_file?.reduce(
        (acc, cur) => {
          const { type } = cur;

          if (type === 'THUMBNAIL') {
            acc['thumbnail'] = `${STORE_URL}/${cur?.file_url}`;
          } else if (type === 'STORE') {
            acc['files']?.push(`${STORE_URL}/${cur?.file_url}`);
          }

          return acc;
        },
        { thumbnail: null, files: [] }
      );

      return {
        ...rest,
        ...store_information,
        ...files,
      };
    });

    return newStores;
  }, [Stores]);

  /**
   * 매장 초기 데이터 설정
   */
  React.useEffect(() => {
    setData(StoreList);
  }, [StoreList]);

  /* ===== RENDER ===== */
  return (
    <>
      <FindStorePresenter
        screenSize={screenSize}
        stores={data}
        onSearch={handleSearchStore}
        inputValue={inputValue}
        setInputValue={setInputValue}
        isLoading={isLoading}
      />
    </>
  );
};

export default FindStoreContainer;
